module.exports = __webpack_public_path__ + "img/chivas-footer-logo.acf667b0.svg";